/* Timbrica — /prohibited-items: поиск по предметам и вердикты.
 *
 * ⚠️ ВОПРОС У ЧЕЛОВЕКА ОДИН, А ОТВЕТОВ ДВА. «Можно ли повербанк» не имеет
 * одного ответа: в салон можно, в багаж нельзя, и именно эта пара — то, ради
 * чего сюда пришли. Поэтому вердикт всегда рисуется двумя колонками, даже
 * когда они совпадают: колонка, показанная только при расхождении, приучает
 * читать одну.
 *
 * ⚠️ ПОИСК ИЩЕТ ПО СИНОНИМАМ, А НЕ ПО НАЗВАНИЮ. Человек ищет тем словом,
 * которым эту вещь называет он: «повербанк», «внешний аккумулятор»,
 * «пауэрбанк». Название в реестре одно, поэтому синонимы лежат в той же
 * строке перевода через «|» — тогда они переводятся вместе с названием и не
 * могут от него отстать.
 */

const CFG = window.PI_CFG || {};
const T = CFG.t || {};
const ITEMS = CFG.items || {};

const tr = (k) => (T[k] != null ? T[k] : k);
const $ = (id) => document.getElementById(id);
const ae = (ev, p) => { try { window.__ae && window.__ae(ev, p || {}); } catch (e) {} };
const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g,
  (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

// ⚠️ Диапазон диакритики пишется КОДАМИ, а не самими знаками: комбинирующие
// символы в исходнике невидимы и не переживают перекодировку файла.
const fold = (s) => (s || '').toString().normalize('NFD')
  .replace(/\p{Diacritic}/gu, '').replace(/ё/g, 'е').toLowerCase().trim();

let jur = CFG.defaultJur || 'intl';

/** Названия и синонимы одного предмета. Первое — то, что показываем. */
function names(key) {
  return tr('item_' + key).split('|').map((s) => s.trim()).filter(Boolean);
}

/**
 * Вердикт с учётом страны. Национальные правила отличаются в немногих, но
 * самых болезненных местах, и общий ответ там просто неверен.
 */
function verdictFor(key) {
  const it = ITEMS[key] || {};
  const base = { cabin: it.cabin, checked: it.checked, note: it.note || null };
  const over = (it.jur || {})[jur];
  return over ? Object.assign({}, base, over) : base;
}

function search(q) {
  const needle = fold(q);
  if (needle.length < 2) return [];
  const safe = needle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const wordStart = new RegExp('(^|\\s)' + safe);
  const out = [];
  for (const key of Object.keys(ITEMS)) {
    let score = 0;
    for (const n of names(key)) {
      const f = fold(n);
      if (f === needle) { score = Math.max(score, 1000); continue; }
      if (f.startsWith(needle)) { score = Math.max(score, 700); continue; }
      // Слово внутри названия: «сыр» в «твёрдый сыр».
      if (wordStart.test(f)) { score = Math.max(score, 500); continue; }
      if (f.includes(needle)) score = Math.max(score, 250);
    }
    if (score) out.push([score, key]);
  }
  out.sort((a, b) => b[0] - a[0] || names(a[1])[0].localeCompare(names(b[1])[0]));
  return out.map((x) => x[1]);
}

/**
 * Плашка вердикта. Цвет берётся из общей палитры `partials/verdict-palette`
 * (проверена в обеих темах), а НЕ из своих литералов: собственные
 * #0e9c70/#b07d14 были подобраны под светлую тему и на тёмной давали тёмное
 * по тёмному.
 */
const V_CLASS = { yes: 'v-yes', limited: 'v-warn', no: 'v-no', special: 'v-info' };

function verdictHtml(kind, value) {
  const cls = V_CLASS[value] || 'v-none';
  return '<div class="pi-cell">' +
    '<span class="pi-cell-l">' + esc(tr(kind === 'cabin' ? 'col_cabin' : 'col_checked')) + '</span>' +
    '<span class="v-chip ' + cls + '"><i class="v-dot"></i>' + esc(tr('v_' + value)) + '</span></div>';
}

/**
 * Строка предмета. Развёрнута она или нет, решает `open`.
 *
 * ⚠️ ПОДРОБНОСТЬ НЕ ПРЯЧЕТСЯ НАСОВСЕМ: причина запрета и есть товар. «Нельзя»
 * без причины не запоминается, и через месяц человек спрашивает снова.
 * Поэтому единственный найденный предмет всегда раскрыт, а в списке
 * раскрывается тот, по которому нажали.
 */
function rowHtml(key, open) {
  const it = ITEMS[key] || {};
  const v = verdictFor(key);
  const ns = names(key);
  const parts = [];

  parts.push('<button type="button" class="pi-row" data-item="' + esc(key) + '"' +
    ' aria-expanded="' + (open ? 'true' : 'false') + '" aria-controls="d-' + esc(key) + '">');
  parts.push('<span class="pi-row-n">' + esc(ns[0]) +
    '<span class="cat">' + esc(tr('cat_' + it.cat)) + '</span></span>');
  parts.push('<span class="pi-cells" style="display:contents">' +
    verdictHtml('cabin', v.cabin) + verdictHtml('checked', v.checked) + '</span>');
  parts.push('</button>');

  if (!open) return parts.join('');

  const d = ['<div class="pi-detail" id="d-' + esc(key) + '">'];
  if (v.note) d.push('<p class="pi-note">' + esc(tr('note_' + v.note)) + '</p>');

  // ⚠️ Расхождение между странами показывается ОТДЕЛЬНОЙ строкой, а не
  // растворяется в примечании: именно эти несколько предметов и стоят людям
  // вещей, потому что дома правило было другим.
  if (it.differs) {
    d.push('<p class="pi-differs"><b>' + esc(tr('differs_label')) + ':</b> ' +
      esc(tr('differs_' + it.differs)) + '</p>');
  }
  if (ns.length > 1) d.push('<p class="pi-syn">' + esc(ns.slice(1).join(' · ')) + '</p>');
  d.push('<div class="tc-actions pi-share"><button type="button" class="tc-btn ghost sm"' +
    ' data-share="' + esc(key) + '">' + esc(tr('share_item')) + '</button></div>');
  d.push('</div>');

  return parts.join('') + d.join('');
}

/** Ключ раскрытой строки. Один: две открытые подробности спорят за внимание. */
let openKey = null;
let shown = [];

function renderList(keys, q, headline) {
  const out = $('pi-results');
  shown = keys;
  if (!keys.length) {
    out.innerHTML = '<div class="pi-empty"><b>' + esc(tr('no_match_title')) + '</b>' +
      esc(tr('no_match').replace(':q', q || '')) + '</div>';
    ae('pi_no_match', { q: (q || '').slice(0, 40) });
    return;
  }
  // Единственный найденный предмет раскрыт сразу: искали именно его.
  if (keys.length === 1) openKey = keys[0];
  else if (!keys.includes(openKey)) openKey = null;

  // headline === false — заголовка нет вовсе: у ссылки на один предмет
  // название и так стоит в строке, и заголовок повторяет его дважды.
  const head = headline === false ? '' : (headline || tr('results_count').replace(':n', String(keys.length)));
  out.innerHTML = (head ? '<p class="pi-count">' + esc(head) + '</p>' : '') +
    keys.map((k) => rowHtml(k, k === openKey)).join('');
}

/**
 * Перерисовать текущий список, сохранив заголовок.
 *
 * Раскрытие строки — это смена состояния, которую приятно показать
 * переходом. Зовём ОБЩИЙ примитив `window.__viewTransition`, а не
 * `document.startViewTransition` напрямую: у перехода три промиса, и когда
 * он пропущен (вкладка скрыта, другой переход вытеснил этот), два из них
 * ОТВЕРГАЮТСЯ — каждый такой клик давал бы unhandledrejection. Примитив
 * гасит все три, проверяет prefers-reduced-motion и выполняет функцию
 * ровно один раз; вернул null — значит перехода не будет и всё уже
 * выполнено синхронно. То есть на браузере без View Transitions это
 * работает ровно как раньше.
 */
function repaint() {
  const out = $('pi-results');
  if (!shown.length) return;
  const paint = () => {
    const head = out.querySelector('.pi-count');
    out.innerHTML = (head ? head.outerHTML : '') + shown.map((k) => rowHtml(k, k === openKey)).join('');
  };
  if (window.__viewTransition) window.__viewTransition(paint);
  else paint();
}

/**
 * Что показать до первого запроса.
 *
 * ⚠️ Пустая страница с полем поиска перекладывает на человека задачу угадать,
 * какими словами тут разговаривают, и часть уходит, не набрав ничего. Поэтому
 * сразу видны предметы, вокруг которых и строится весь спрос: те, где салон и
 * багаж отвечают ПО-РАЗНОМУ, и те, которые не считают проблемой, пока их не
 * отберут.
 *
 * Ссылка вида …#i-power-bank открывает конкретный предмет — так ответ можно
 * переслать тому, кто прямо сейчас собирает чемодан.
 */
function showStart() {
  const hash = decodeURIComponent((location.hash || '').replace(/^#i-/, ''));
  if (hash && ITEMS[hash]) {
    renderList([hash], '', false);
    ae('pi_deep_link', { item: hash });
    return;
  }
  const pop = (CFG.popular || []).filter((k) => ITEMS[k]);
  if (pop.length) renderList(pop, '', tr('popular_title'));
}

function mount() {
  const input = $('pi-search');
  const cats = $('pi-cats');
  if (!input) return;

  // null — заведомо не равен никакому запросу (запрос всегда строка),
  // и, в отличие от строки-маркера, его нечем испортить.
  let last = null;
  const run = () => {
    const q = input.value.trim();
    if (q === last) return;
    last = q;
    if (q.length < 2) { showStart(); return; }
    const keys = search(q);
    renderList(keys, q);
    ae('pi_search', { hits: keys.length });
  };
  input.addEventListener('input', run);

  if (cats) {
    cats.addEventListener('click', (e) => {
      const b = e.target.closest('[data-cat]');
      if (!b) return;
      const c = b.getAttribute('data-cat');
      input.value = '';
      last = null;
      const keys = Object.keys(ITEMS).filter((k) => (ITEMS[k] || {}).cat === c);
      keys.sort((x, y) => names(x)[0].localeCompare(names(y)[0]));
      renderList(keys, '', tr('cat_' + c));
      [...cats.querySelectorAll('[data-cat]')].forEach((x) => x.classList.toggle('on', x === b));
      ae('pi_category', { cat: c });
      // ⚠️ block:'nearest' — страницу не дёргаем, если список и так виден.
      $('pi-results').scrollIntoView({ block: 'nearest' });
    });
  }

  // ── страна: сегмент вместо <select> ──────────────────────────────────
  // Выбор страны запоминается: человек летает из одного и того же аэропорта.
  const seg = $('pi-jur');
  if (seg) {
    try {
      const saved = window.__toolSettings
        ? window.__toolSettings.load('prohibited-items', 'jur', jur) : jur;
      if (saved && seg.querySelector('[data-jur="' + saved + '"]')) jur = saved;
    } catch (e) {}
    seg.querySelectorAll('[data-jur]').forEach((b) => {
      const on = b.dataset.jur === jur;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    seg.addEventListener('click', (e) => {
      const b = e.target.closest('[data-jur]');
      if (!b) return;
      jur = b.dataset.jur;
      seg.querySelectorAll('[data-jur]').forEach((x) => {
        x.classList.toggle('on', x === b);
        x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
      });
      try { window.__toolSettings && window.__toolSettings.save('prohibited-items', 'jur', jur); } catch (e) {}
      ae('pi_jurisdiction', { jur });
      last = null;
      // Вердикты зависят от страны — перерисовываем ТО ЖЕ, что показано,
      // а не сбрасываем человека в начало.
      if (shown.length) repaint(); else run();
    });
  }

  // ── раскрытие строки и «поделиться» ─────────────────────────────────
  const res = $('pi-results');
  if (res) {
    res.addEventListener('click', (e) => {
      const sh = e.target.closest('[data-share]');
      if (sh) {
        const url = location.origin + location.pathname + '#i-' + encodeURIComponent(sh.dataset.share);
        const done = () => { try { window.__toast && window.__toast(tr('share_copied'), 'success'); } catch (x) {} };
        // Системный лист там, где он есть: на телефоне это и есть «переслать».
        if (navigator.share) navigator.share({ url }).catch(() => {});
        else if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, () => {});
        ae('pi_share', { item: sh.dataset.share });
        return;
      }
      const row = e.target.closest('[data-item]');
      if (!row) return;
      const k = row.dataset.item;
      openKey = openKey === k ? null : k;
      repaint();
      if (openKey) ae('pi_open', { item: openKey });
    });
  }

  showStart();
  window.addEventListener('hashchange', () => { last = null; input.value = ''; showStart(); });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
else mount();
